import { c as _c } from "react/compiler-runtime";
import './payment-method-icon.scss';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { CreditCardEnum } from '@sola/schema/dotcom/checkout/billingInfo.ts';
import { GraphQLSupporterPaymentMethod } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { IconNames } from '@sola/schema/lib/icons/icon-names.ts';
const ccFallbackIconName = 'credit-card-02';

/**
 * Get icon component.
 */
export const getIconName = (paymentMethod: GraphQLSupporterPaymentMethod) => {
  if (paymentMethod.creditCard?.cardType) {
    return {
      [CreditCardEnum.Amex]: 'card-amex',
      'american express': 'card-amex',
      [CreditCardEnum.Discover]: 'card-discover',
      [CreditCardEnum.Mastercard]: 'card-mastercard',
      'master card': 'card-mastercard',
      [CreditCardEnum.Visa]: 'card-visa'
    }[paymentMethod.creditCard.cardType.toLowerCase()] || ccFallbackIconName;
  }
  if (paymentMethod.ach) {
    return 'bank';
  }

  // What else?
  return '';
};
export interface PaymentMethodIconProps {
  paymentMethod: GraphQLSupporterPaymentMethod;
}
export const PaymentMethodIcon: React.FC<PaymentMethodIconProps> = t0 => {
  const $ = _c(7);
  const {
    paymentMethod
  } = t0;
  let t1;
  if ($[0] !== paymentMethod) {
    t1 = getIconName(paymentMethod);
    $[0] = paymentMethod;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconName = t1;
  if (!iconName) {
    return null;
  }
  const t2 = !!paymentMethod?.ach;
  let t3;
  if ($[2] !== t2) {
    t3 = cn("PaymentMethodIcon__icon", {
      "PaymentMethodIcon__icon-bank rounded-sm p-snug-xl": t2
    });
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = iconName as IconNames;
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = <ArkIcon className={t3} iconName={t4} />;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};